import { Message } from "primereact/message";
import React from "react";

const PayslipMessage = ({ data }) => {
  return (
    <Message
      severity={data.severity}
      text={data?.text}
      className={`justify-content-start ${data?.className}`}
      icon={data?.icon}
    />
  );
};

export default PayslipMessage;
